import { render, staticRenderFns } from "./ExpenseTransactionForm.vue?vue&type=template&id=2b73084b"
import script from "./ExpenseTransactionForm.vue?vue&type=script&lang=js"
export * from "./ExpenseTransactionForm.vue?vue&type=script&lang=js"
import style0 from "./ExpenseTransactionForm.vue?vue&type=style&index=0&id=2b73084b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports